import { LoadingData } from '@hwm/ui-lib';
import { t } from '@lingui/macro';
import { useMemo } from 'react';
import { AccountHierarchy } from './AccountHierarchy';
import { SaveSelectedSitesList } from './SaveSelectedSitesList';
import { SelectedSitesLists } from './SelectedSitesLists';
import { SiteList } from './SiteList';

export enum SidebarKeys {
  accounts = 'accounts',
  siteList = 'sites',
  selectedLists = 'lists',
  createList = 'create',
}

export const useSidebarContent = () => {
  const sidebarData = useMemo(
    (): Record<SidebarKeys, { header: string; component: JSX.Element }> => ({
      [SidebarKeys.accounts]: {
        header: t({
          message: 'Accounts',
          id: '[Sidebar.Accounts]',
        }),
        component: <AccountHierarchy />,
      },
      [SidebarKeys.siteList]: {
        header: t({
          message: 'Site List',
          id: '[Sidebar.SiteList]',
        }),
        component: <SiteList />,
      },
      [SidebarKeys.selectedLists]: {
        header: t({
          message: 'Load Selected List',
          id: '[Sidebar.LoadList]',
        }),
        component: <SelectedSitesLists />,
      },
      [SidebarKeys.createList]: {
        header: t({
          message: 'Save Selected List As',
          id: '[Sidebar.SaveList]',
        }),
        component: <SaveSelectedSitesList />,
      },
    }),
    []
  );

  const loadingData = useMemo(
    () => ({
      header: '',
      component: <LoadingData />,
    }),
    []
  );

  return { sidebarData, loadingData };
};
